import React from "react";

import {
  Flex,
  Drawer,
  DrawerBody,
  DrawerFooter,
  DrawerHeader,
  DrawerOverlay,
  DrawerContent,
  DrawerCloseButton,
  useDisclosure,
  Button,
  Input,
  UnorderedList,
  ListItem,
  Box,
} from "@chakra-ui/react";

//components
import Logo from "../logo/Logo";
import NavItem from "./NavItem";

//Navbar Data
import NavbarData from "./NavbarData";
import { Link, NavLink } from "react-router-dom";
import { useNavigate } from "react-router-dom";
const Navbar = () => {
  const { isOpen, onOpen, onClose } = useDisclosure();
  const btnRef = React.useRef();
const navigate = useNavigate();
  return (
    <Flex
      id="navbar"
      zIndex={100}
      w={"100%"}
      py={"3rem"}
      px={{ base: "3rem", "md": "5rem", lg: "15rem" }}
      alignItems={"center"}
      justifyContent="space-between"
      position="absolute"
    >
      <Flex justifyContent={"center"} alignItems={"center"}>
        <Logo />
      </Flex>
      <Flex display={{ base: "none", md: "flex" }}>
        {NavbarData.map((item, index) => {
          return <NavItem key={index} item={item} />;
        })}
      </Flex>
      <Flex
        flexDir={"column"}
        justifyContent={"center"}
        alignItems={"center"}
        color={"white"}
        ref={btnRef}
        onClick={onOpen}
        display={{ base: "flex", md: "none" }}
      >
        <i
          className="fa-solid fa-bars"
          style={{ margin: "1rem 0", width: "50%", fontSize: "3rem" }}
        ></i>
      </Flex>
      <Drawer
        display={{ base: "flex", md: "none" }}
        size={"xl"}
        isOpen={isOpen}
        placement="right"
        onClose={onClose}
        finalFocusRef={btnRef}
        fontSize={"4rem"}
      >
        <DrawerOverlay />
        <DrawerContent>
          <DrawerCloseButton
            m={"3rem 3rem"}
            fontSize={"2rem"}
            color={"whiteAlpha.900"}
            
          />

          <DrawerBody bg={"#1A202C"} padding={"5rem 3rem"}>
            <UnorderedList
              color={"whiteAlpha.900"}
              listStyleType={"none"}
              fontSize={"2.0rem"}
              textTransform={"uppercase"}
            >
              {NavbarData.map((item, index) => {
                return (
                  <Box key={index}>
                    <NavLink
                      onClick={onClose}
                      to={{ pathname: item.url }}
                      key={index}
                    >
                      <ListItem my={".75rem"}>{item.name}</ListItem>
                    </NavLink>

                    <Box bg={"#EA0F0F"} h="3px" w={"5rem"} mb={"1rem"}></Box>

                     {item.subMenu
  ? item.subMenu.map((el, index) => {
      return (
        <Box key={index} ml={"1rem"} my={".5rem"}>
          <Link
   to={{ pathname: el.url, state: { id: el.id } }}
  
  
  onClick={() => {
    onClose();

    setTimeout(() => {
      const element = document.querySelector(el.id);

      if (element) {
        element.scrollIntoView({
          behavior: "smooth",
          block: "start",
        });
      }
    }, 50);
  }}
>
          
            <ListItem
              fontSize={"1.6rem"}
              cursor={"pointer"}
              _hover={{ color: "#EA0F0F" }}
              transition={"all 0.3s"}
              width={"fit-content"}
            >
              {el.name}
            </ListItem>
          </Link>

          <Box
            bg={"white"}
            h="1px"
            w="70%"
            mt={"0.3rem"}
          />
        </Box>
                            
                        
                      
                            
                );
              })
                      : null}
            </Box>
            );
              })}
          </UnorderedList>
        </DrawerBody>
      </DrawerContent>
    </Drawer>
    </Flex >
  );
};

export default Navbar;
